"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
const useAuth_1 = __importDefault(require("./useAuth"));
const dataFetchReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
            return {
                ...state,
                isLoading: true,
                error: undefined,
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                isLoading: false,
                error: undefined,
                data: action.payload,
            };
        case 'FETCH_FAILURE':
            return {
                data: undefined,
                isLoading: false,
                error: action.error,
            };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
const configureOptions = (opts, authHeader) => {
    const defaultHeaders = {
        Authorization: authHeader,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    const configuredOptions = {
        ...opts,
    };
    if (opts.headers) {
        configuredOptions.headers = {
            ...defaultHeaders,
            ...opts.headers,
        };
    }
    else {
        configuredOptions.headers = defaultHeaders;
    }
    return configuredOptions;
};
function useGet({ url, options, initialFetch, success, failure }) {
    const { authHeader } = (0, useAuth_1.default)();
    const [state, dispatch] = (0, react_1.useReducer)(dataFetchReducer, {
        isLoading: initialFetch,
        error: null,
        data: null,
    });
    const fetchData = async (uri, opts = {}, handlers) => {
        const handleError = (e) => {
            if (handlers.failure) {
                handlers.failure(e);
            }
            dispatch({ type: 'FETCH_FAILURE', error: e });
        };
        const configuredOptions = configureOptions(opts, authHeader);
        dispatch({ type: 'FETCH_INIT' });
        try {
            const result = await axios_1.default.get(uri, configuredOptions);
            dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
            if (handlers.success) {
                handlers.success(result.data);
            }
            return result;
        }
        catch (error) {
            handleError(error);
        }
    };
    (0, react_1.useEffect)(() => {
        const handlers = {
            success,
            failure,
        };
        if (initialFetch && url) {
            fetchData(url, options, handlers);
        }
    }, [url]);
    const get = ({ url: newUrl, options: newOptions, success: newSuccess, failure: newFailure } = {}) => {
        const handlers = {
            success: newSuccess || success,
            failure: newFailure || failure,
        };
        return fetchData(newUrl || url, newOptions || options, handlers);
    };
    return {
        ...state,
        get,
    };
}
exports.default = useGet;
